import { queryOptions } from '@tanstack/react-query'
import { apiGet } from './client'

/**
 * Sertarul rapid din dreapta - `application/controllers/Quick.php`
 * (`device_details`, `user_details`, `company_details`, `office_details`,
 * `owner_details`, `ticket_devices`). Capetele sunt in
 * `EaseedeskQuickController`; ce nu e in firmele omului vine 404.
 */

export interface Comm {
  key: 'live' | 'fresh' | 'ok' | 'stale' | 'lost' | string
  label: string
}

export interface QuickDevice {
  id: number
  name: string
  owner: string | null
  subscriptions: number
  comm: Comm
}

export interface QuickUser {
  first_name: string
  last_name: string
  company: string
  email: string
  phone: string
  mobile: string
  position: string
}

export interface QuickPerson {
  name: string
  email: string
  phone: string
  phone2: string
}

export interface QuickCompany {
  name: string
  address: string
  phone: string
  email: string
  contact_person: string
  working_program: string
  created: string
  it_manager: QuickPerson | null
  it_responsible: QuickPerson | null
}

export interface QuickOffice {
  name: string
  gmt: string
  timezone: string
  address: string
  address_2: string
  phone: string
  email: string
  zip: string
  region: string
  district: string
  state: string
  city: string
  manager: string
  latitude: string
  longitude: string
  work_program: string
  program: Array<{ day: string; start_program: string; end_program: string }>
}

export interface QuickDeviceRow {
  id: number
  name: string
  type: string
  type_id: number
  last_seen: string | null
  comm: Comm
}

export interface QuickOwner {
  first_name: string
  last_name: string
  company: string
  email: string
  phone: string
  mobile: string
  position: string
  address: string
  city: string
  state: string
  zip: string
  created: string
  description: string
  devices: QuickDeviceRow[]
  services: Array<{ service_name: string; group_name: string; activated: number }>
  subscriptions: Array<{
    workorder_id: number
    sku_name: string
    devices_left: number
    activated: number
    devices: Array<{ device_name: string; device_type_name: string }>
  }>
}

/** Clopotelul de chat (`MyChat` din general.js): conversatiile cu mesaje necitite si mesajele unui client. */
export interface ChatMessage {
  ID: number
  ticket_id: number
  message: string
  created: string
}

export interface ChatConversation {
  messages: number
  user_id: number
  last_message_id: number
  user: string
  last_message: ChatMessage | null
}

export interface ChatCustomer {
  customer: { ID: number; Nume: string; Prenume: string; Email: string }
  messages: ChatMessage[]
}

export type QuickKind = 'device' | 'user' | 'company' | 'office' | 'owner' | 'ticket-devices' | 'chat' | 'chat-customer'

const PATHS: Record<QuickKind, (id: number) => string> = {
  device: (id) => `/easeedesk/quick/device/${id}`,
  user: (id) => `/easeedesk/quick/user/${id}`,
  company: (id) => `/easeedesk/quick/company/${id}`,
  office: (id) => `/easeedesk/quick/office/${id}`,
  owner: (id) => `/easeedesk/quick/owner/${id}`,
  'ticket-devices': (id) => `/easeedesk/quick/ticket/${id}/devices`,
  chat: () => '/easeedesk/chat/mine',
  'chat-customer': (id) => `/easeedesk/chat/customers/${id}`,
}

export function quickPanelQuery<T>(kind: QuickKind, id: number) {
  return queryOptions({
    queryKey: ['easeedesk', 'quick', kind, id],
    queryFn: () => apiGet<T>(PATHS[kind](id)),
  })
}
